import React from "react";
import { LazyLoadImage, LineDots } from "../../../../../core/atoms";
import classNames from "classnames";

import "./aboutHero.scss";

export const AboutHero = () => {
  return (
    <div className="about-hero">
      <div className="about-hero__image about-hero__image--left">
        <LazyLoadImage
          src="https://resources.travellocal.com/about-us/about-us-hero-left.svg"
          alt=""
        />
      </div>
      <div className="about-hero__blurb column is-7-tablet is-5-desktop">
        <h1 className={classNames("about-hero__title", "text--caps")}>About Us</h1>
        <h2>Local knowledge makes a world of difference</h2>
        <p>The greatest holidays take local know-how. Our handpicked local experts know your destination
         better than anyone because they live there. They organise unique and authentic trips specifically designed around your hopes and needs.
        </p>        
      </div>
      <div className="about-hero__image about-hero__image--right">
        <LazyLoadImage
          src="https://resources.travellocal.com/about-us/about-us-hero-right.svg"
          alt=""
        />
      </div>
    </div>
  );
};
